// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/rfi_sections.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
import { GetRfiReadinessRequest, GetRfiReadinessResponse } from "./rfi_readiness_pb";
import { MethodKind } from "@bufbuild/protobuf";
import { AppendRfiSubmissionReceiptRequest, AppendRfiSubmissionReceiptResponse, AttachRfiPackageArtifactRequest, AttachRfiPackageArtifactResponse, CaptureRfiPackageVersionRequest, CaptureRfiPackageVersionResponse, CreateRfiPackageRequest, CreateRfiPackageResponse, DownloadRfiPackageArtifactRequest, DownloadRfiPackageArtifactResponse, GenerateRfiPackageArtifactRequest, GenerateRfiPackageArtifactResponse, GetRfiPackageVersionRequest, GetRfiPackageVersionResponse, ListRfiPackagesRequest, ListRfiPackagesResponse, ListRfiSubmissionReceiptsRequest, ListRfiSubmissionReceiptsResponse, ListRfiSubmissionsRequest, ListRfiSubmissionsResponse, RecordRfiSubmissionRequest, RecordRfiSubmissionResponse, SelectRfiPackageVersionRequest, SelectRfiPackageVersionResponse } from "./rfi_packages_pb";
import { ApproveRfiAnswerRequest, ApproveRfiAnswerResponse, CheckRfiSectionDocumentAccessRequest, CheckRfiSectionDocumentAccessResponse, ConfirmRfiEntityRequest, ConfirmRfiEntityResponse, CreateRfiFollowUpRequest, CreateRfiFollowUpResponse, CreateRfiLaborCategoriesRequest, CreateRfiLaborCategoriesResponse, CreateRfiSectionDocumentRequest, CreateRfiSectionDocumentResponse, CreateRfiSectionRequest, CreateRfiSectionResponse, CreateRfiSignalRequest, CreateRfiSignalResponse, EnsureRfiAnswerSectionsRequest, EnsureRfiAnswerSectionsResponse, EnsureRfiCapabilityStatementRequest, EnsureRfiCapabilityStatementResponse, EnsureRfiResponseDocumentRequest, EnsureRfiResponseDocumentResponse, GetRfiNavCountsRequest, GetRfiNavCountsResponse, GetRfiWorkspaceHomeRequest, GetRfiWorkspaceHomeResponse, LinkRfiEntityRequest, LinkRfiEntityResponse, ListRfiEntitiesRequest, ListRfiEntitiesResponse, ListRfiFollowUpsRequest, ListRfiFollowUpsResponse, ListRfiLaborCategoriesRequest, ListRfiLaborCategoriesResponse, ListRfiSectionDocumentHistoryRequest, ListRfiSectionDocumentHistoryResponse, ListRfiSectionEventsRequest, ListRfiSectionEventsResponse, ListRfiSectionsRequest, ListRfiSectionsResponse, MoveRfiSectionRequest, MoveRfiSectionResponse, ReadRfiSectionDocumentRequest, ReadRfiSectionDocumentResponse, ReindexRfiFinalAnswersRequest, ReindexRfiFinalAnswersResponse, RemoveRfiLaborCategoryRequest, RemoveRfiLaborCategoryResponse, RemoveRfiSectionRequest, RemoveRfiSectionResponse, RequestRfiAnswerChangesRequest, RequestRfiAnswerChangesResponse, RequestRfiAnswerReviewRequest, RequestRfiAnswerReviewResponse, RestoreRfiSectionDocumentRequest, RestoreRfiSectionDocumentResponse, RetractRfiSignalRequest, RetractRfiSignalResponse, SaveRfiSectionDocumentRequest, SaveRfiSectionDocumentResponse, SearchFinalAnswersRequest, SearchFinalAnswersResponse, SetRfiQuestionPursuitScopeRequest, SetRfiQuestionPursuitScopeResponse, UnlinkRfiEntityRequest, UnlinkRfiEntityResponse, UpdateRfiFollowUpRequest, UpdateRfiFollowUpResponse, UpdateRfiLaborCategoryMatchRequest, UpdateRfiLaborCategoryMatchResponse, UpdateRfiLaborCategoryRequest, UpdateRfiLaborCategoryResponse, UpdateRfiSectionRequest, UpdateRfiSectionResponse, UpdateRfiSubmissionFactsRequest, UpdateRfiSubmissionFactsResponse } from "./rfi_sections_pb";
/**
 * RfiSectionService is the browser edge for SAD-516 / RFI-05: the dynamic RFI
 * response outline, section ownership and RFI-owned follow-ups. A thin layer
 * over pangaea's RfiSectionGatewayService.
 *
 * Every RPC is keyed by rfi_response_project_id, the same id the existing RFI
 * RPCs use (the pangaea row id or the zou project id both resolve). Tenant and
 * actor come from the gateway principal only; no request field carries them.
 * Reads need `read` on the RFI, mutations need `update`. A section's work and
 * review state never changes the RFI's own status.
 *
 * @generated from service mono.projectdata.v1.RfiSectionService
 */ export const RfiSectionService = {
    typeName: "mono.projectdata.v1.RfiSectionService",
    methods: {
        /**
     * @generated from rpc mono.projectdata.v1.RfiSectionService.GetRfiReadiness
     */ getRfiReadiness: {
            name: "GetRfiReadiness",
            I: GetRfiReadinessRequest,
            O: GetRfiReadinessResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.RfiSectionService.CaptureRfiPackageVersion
     */ captureRfiPackageVersion: {
            name: "CaptureRfiPackageVersion",
            I: CaptureRfiPackageVersionRequest,
            O: CaptureRfiPackageVersionResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.RfiSectionService.GetRfiPackageVersion
     */ getRfiPackageVersion: {
            name: "GetRfiPackageVersion",
            I: GetRfiPackageVersionRequest,
            O: GetRfiPackageVersionResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.RfiSectionService.RecordRfiSubmission
     */ recordRfiSubmission: {
            name: "RecordRfiSubmission",
            I: RecordRfiSubmissionRequest,
            O: RecordRfiSubmissionResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.RfiSectionService.ListRfiSubmissions
     */ listRfiSubmissions: {
            name: "ListRfiSubmissions",
            I: ListRfiSubmissionsRequest,
            O: ListRfiSubmissionsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.RfiSectionService.AppendRfiSubmissionReceipt
     */ appendRfiSubmissionReceipt: {
            name: "AppendRfiSubmissionReceipt",
            I: AppendRfiSubmissionReceiptRequest,
            O: AppendRfiSubmissionReceiptResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.RfiSectionService.ListRfiSubmissionReceipts
     */ listRfiSubmissionReceipts: {
            name: "ListRfiSubmissionReceipts",
            I: ListRfiSubmissionReceiptsRequest,
            O: ListRfiSubmissionReceiptsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.RfiSectionService.ListRfiPackages
     */ listRfiPackages: {
            name: "ListRfiPackages",
            I: ListRfiPackagesRequest,
            O: ListRfiPackagesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.RfiSectionService.CreateRfiPackage
     */ createRfiPackage: {
            name: "CreateRfiPackage",
            I: CreateRfiPackageRequest,
            O: CreateRfiPackageResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.RfiSectionService.SelectRfiPackageVersion
     */ selectRfiPackageVersion: {
            name: "SelectRfiPackageVersion",
            I: SelectRfiPackageVersionRequest,
            O: SelectRfiPackageVersionResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.RfiSectionService.GenerateRfiPackageArtifact
     */ generateRfiPackageArtifact: {
            name: "GenerateRfiPackageArtifact",
            I: GenerateRfiPackageArtifactRequest,
            O: GenerateRfiPackageArtifactResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.RfiSectionService.AttachRfiPackageArtifact
     */ attachRfiPackageArtifact: {
            name: "AttachRfiPackageArtifact",
            I: AttachRfiPackageArtifactRequest,
            O: AttachRfiPackageArtifactResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.RfiSectionService.DownloadRfiPackageArtifact
     */ downloadRfiPackageArtifact: {
            name: "DownloadRfiPackageArtifact",
            I: DownloadRfiPackageArtifactRequest,
            O: DownloadRfiPackageArtifactResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.RfiSectionService.CreateRfiSectionDocument
     */ createRfiSectionDocument: {
            name: "CreateRfiSectionDocument",
            I: CreateRfiSectionDocumentRequest,
            O: CreateRfiSectionDocumentResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.RfiSectionService.ReadRfiSectionDocument
     */ readRfiSectionDocument: {
            name: "ReadRfiSectionDocument",
            I: ReadRfiSectionDocumentRequest,
            O: ReadRfiSectionDocumentResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.RfiSectionService.SaveRfiSectionDocument
     */ saveRfiSectionDocument: {
            name: "SaveRfiSectionDocument",
            I: SaveRfiSectionDocumentRequest,
            O: SaveRfiSectionDocumentResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.RfiSectionService.ListRfiSectionDocumentHistory
     */ listRfiSectionDocumentHistory: {
            name: "ListRfiSectionDocumentHistory",
            I: ListRfiSectionDocumentHistoryRequest,
            O: ListRfiSectionDocumentHistoryResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.RfiSectionService.RestoreRfiSectionDocument
     */ restoreRfiSectionDocument: {
            name: "RestoreRfiSectionDocument",
            I: RestoreRfiSectionDocumentRequest,
            O: RestoreRfiSectionDocumentResponse,
            kind: MethodKind.Unary
        },
        /**
     * Used by shared document reads and callbacks. Only read/update are accepted.
     *
     * @generated from rpc mono.projectdata.v1.RfiSectionService.CheckRfiSectionDocumentAccess
     */ checkRfiSectionDocumentAccess: {
            name: "CheckRfiSectionDocumentAccess",
            I: CheckRfiSectionDocumentAccessRequest,
            O: CheckRfiSectionDocumentAccessResponse,
            kind: MethodKind.Unary
        },
        /**
     * WRT-05: the RFI's one ONLYOFFICE response document (one anchored Heading 2
     * per government question). Idempotent; needs update and writing_workspace_v1.
     *
     * @generated from rpc mono.projectdata.v1.RfiSectionService.EnsureRfiResponseDocument
     */ ensureRfiResponseDocument: {
            name: "EnsureRfiResponseDocument",
            I: EnsureRfiResponseDocumentRequest,
            O: EnsureRfiResponseDocumentResponse,
            kind: MethodKind.Unary
        },
        /**
     * WRT-05: seed sections for questions added later (and re-insert orphaned
     * answer headings) into the response document.
     *
     * @generated from rpc mono.projectdata.v1.RfiSectionService.EnsureRfiAnswerSections
     */ ensureRfiAnswerSections: {
            name: "EnsureRfiAnswerSections",
            I: EnsureRfiAnswerSectionsRequest,
            O: EnsureRfiAnswerSectionsResponse,
            kind: MethodKind.Unary
        },
        /**
     * WRT-05: RFI record sidebar counts (read).
     *
     * @generated from rpc mono.projectdata.v1.RfiSectionService.GetRfiNavCounts
     */ getRfiNavCounts: {
            name: "GetRfiNavCounts",
            I: GetRfiNavCountsRequest,
            O: GetRfiNavCountsResponse,
            kind: MethodKind.Unary
        },
        /**
     * WRT-16: send an answer for review (update; optional reviewer + note).
     *
     * @generated from rpc mono.projectdata.v1.RfiSectionService.RequestRfiAnswerReview
     */ requestRfiAnswerReview: {
            name: "RequestRfiAnswerReview",
            I: RequestRfiAnswerReviewRequest,
            O: RequestRfiAnswerReviewResponse,
            kind: MethodKind.Unary
        },
        /**
     * WRT-16: approve the answer's region at the current version (FND-25
     * rfi.approve_answer, human principals only) and index it into cp0.
     *
     * @generated from rpc mono.projectdata.v1.RfiSectionService.ApproveRfiAnswer
     */ approveRfiAnswer: {
            name: "ApproveRfiAnswer",
            I: ApproveRfiAnswerRequest,
            O: ApproveRfiAnswerResponse,
            kind: MethodKind.Unary
        },
        /**
     * WRT-16: request changes (update); a note becomes a comment on the region.
     *
     * @generated from rpc mono.projectdata.v1.RfiSectionService.RequestRfiAnswerChanges
     */ requestRfiAnswerChanges: {
            name: "RequestRfiAnswerChanges",
            I: RequestRfiAnswerChangesRequest,
            O: RequestRfiAnswerChangesResponse,
            kind: MethodKind.Unary
        },
        /**
     * WRT-16: backfill / repair the cp0 index of approved answers. Internal
     * principals only (like ConsolidateRfiResponses).
     *
     * @generated from rpc mono.projectdata.v1.RfiSectionService.ReindexRfiFinalAnswers
     */ reindexRfiFinalAnswers: {
            name: "ReindexRfiFinalAnswers",
            I: ReindexRfiFinalAnswersRequest,
            O: ReindexRfiFinalAnswersResponse,
            kind: MethodKind.Unary
        },
        /**
     * WRT-07 (v2.2): per question of this RFI, the closest approved answers of
     * the tenant's other RFIs (cp0 SemanticSearch over TENANT rfi_final_answers,
     * re-authorized per RFI; read + view_sensitive).
     *
     * @generated from rpc mono.projectdata.v1.RfiSectionService.SearchFinalAnswers
     */ searchFinalAnswers: {
            name: "SearchFinalAnswers",
            I: SearchFinalAnswersRequest,
            O: SearchFinalAnswersResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.RfiSectionService.ListRfiSections
     */ listRfiSections: {
            name: "ListRfiSections",
            I: ListRfiSectionsRequest,
            O: ListRfiSectionsResponse,
            kind: MethodKind.Unary
        },
        /**
     * A section needs no question mapping or extraction.
     *
     * @generated from rpc mono.projectdata.v1.RfiSectionService.CreateRfiSection
     */ createRfiSection: {
            name: "CreateRfiSection",
            I: CreateRfiSectionRequest,
            O: CreateRfiSectionResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.RfiSectionService.UpdateRfiSection
     */ updateRfiSection: {
            name: "UpdateRfiSection",
            I: UpdateRfiSectionRequest,
            O: UpdateRfiSectionResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.RfiSectionService.MoveRfiSection
     */ moveRfiSection: {
            name: "MoveRfiSection",
            I: MoveRfiSectionRequest,
            O: MoveRfiSectionResponse,
            kind: MethodKind.Unary
        },
        /**
     * Removing a section with active question mappings is refused with a warning
     * unless confirm is true; either way the unaddressed refs are returned.
     *
     * @generated from rpc mono.projectdata.v1.RfiSectionService.RemoveRfiSection
     */ removeRfiSection: {
            name: "RemoveRfiSection",
            I: RemoveRfiSectionRequest,
            O: RemoveRfiSectionResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.RfiSectionService.ListRfiSectionEvents
     */ listRfiSectionEvents: {
            name: "ListRfiSectionEvents",
            I: ListRfiSectionEventsRequest,
            O: ListRfiSectionEventsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.RfiSectionService.CreateRfiFollowUp
     */ createRfiFollowUp: {
            name: "CreateRfiFollowUp",
            I: CreateRfiFollowUpRequest,
            O: CreateRfiFollowUpResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.RfiSectionService.ListRfiFollowUps
     */ listRfiFollowUps: {
            name: "ListRfiFollowUps",
            I: ListRfiFollowUpsRequest,
            O: ListRfiFollowUpsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.RfiSectionService.UpdateRfiFollowUp
     */ updateRfiFollowUp: {
            name: "UpdateRfiFollowUp",
            I: UpdateRfiFollowUpRequest,
            O: UpdateRfiFollowUpResponse,
            kind: MethodKind.Unary
        },
        /**
     * ----- WRT-06: RFI Home -----
     * Everything on the Home page except the rail team list (read).
     *
     * @generated from rpc mono.projectdata.v1.RfiSectionService.GetRfiWorkspaceHome
     */ getRfiWorkspaceHome: {
            name: "GetRfiWorkspaceHome",
            I: GetRfiWorkspaceHomeRequest,
            O: GetRfiWorkspaceHomeResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.RfiSectionService.UpdateRfiSubmissionFacts
     */ updateRfiSubmissionFacts: {
            name: "UpdateRfiSubmissionFacts",
            I: UpdateRfiSubmissionFactsRequest,
            O: UpdateRfiSubmissionFactsResponse,
            kind: MethodKind.Unary
        },
        /**
     * Scoping a question to a linked pursuit that is not the RFI's primary one
     * posts a question_scope signal.
     *
     * @generated from rpc mono.projectdata.v1.RfiSectionService.SetRfiQuestionPursuitScope
     */ setRfiQuestionPursuitScope: {
            name: "SetRfiQuestionPursuitScope",
            I: SetRfiQuestionPursuitScopeRequest,
            O: SetRfiQuestionPursuitScopeResponse,
            kind: MethodKind.Unary
        },
        /**
     * source 'registry' is service-lane only (a detector with a forwarded human).
     *
     * @generated from rpc mono.projectdata.v1.RfiSectionService.CreateRfiSignal
     */ createRfiSignal: {
            name: "CreateRfiSignal",
            I: CreateRfiSignalRequest,
            O: CreateRfiSignalResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.RfiSectionService.RetractRfiSignal
     */ retractRfiSignal: {
            name: "RetractRfiSignal",
            I: RetractRfiSignalRequest,
            O: RetractRfiSignalResponse,
            kind: MethodKind.Unary
        },
        /**
     * v2.3 (D-SOR): the RFI's people, organizations and vehicle as registry ids.
     *
     * @generated from rpc mono.projectdata.v1.RfiSectionService.ListRfiEntities
     */ listRfiEntities: {
            name: "ListRfiEntities",
            I: ListRfiEntitiesRequest,
            O: ListRfiEntitiesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.RfiSectionService.LinkRfiEntity
     */ linkRfiEntity: {
            name: "LinkRfiEntity",
            I: LinkRfiEntityRequest,
            O: LinkRfiEntityResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.RfiSectionService.ConfirmRfiEntity
     */ confirmRfiEntity: {
            name: "ConfirmRfiEntity",
            I: ConfirmRfiEntityRequest,
            O: ConfirmRfiEntityResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.RfiSectionService.UnlinkRfiEntity
     */ unlinkRfiEntity: {
            name: "UnlinkRfiEntity",
            I: UnlinkRfiEntityRequest,
            O: UnlinkRfiEntityResponse,
            kind: MethodKind.Unary
        },
        /**
     * ----- WRT-07: sidebar pages -----
     *
     * @generated from rpc mono.projectdata.v1.RfiSectionService.ListRfiLaborCategories
     */ listRfiLaborCategories: {
            name: "ListRfiLaborCategories",
            I: ListRfiLaborCategoriesRequest,
            O: ListRfiLaborCategoriesResponse,
            kind: MethodKind.Unary
        },
        /**
     * ids server-side; a duplicate title (case-insensitive) is skipped and counted
     *
     * @generated from rpc mono.projectdata.v1.RfiSectionService.CreateRfiLaborCategories
     */ createRfiLaborCategories: {
            name: "CreateRfiLaborCategories",
            I: CreateRfiLaborCategoriesRequest,
            O: CreateRfiLaborCategoriesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.RfiSectionService.UpdateRfiLaborCategory
     */ updateRfiLaborCategory: {
            name: "UpdateRfiLaborCategory",
            I: UpdateRfiLaborCategoryRequest,
            O: UpdateRfiLaborCategoryResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.RfiSectionService.RemoveRfiLaborCategory
     */ removeRfiLaborCategory: {
            name: "RemoveRfiLaborCategory",
            I: RemoveRfiLaborCategoryRequest,
            O: RemoveRfiLaborCategoryResponse,
            kind: MethodKind.Unary
        },
        /**
     * v2.3: zou runs REG-17 itself and stores ids only; the client never sends a match.
     *
     * @generated from rpc mono.projectdata.v1.RfiSectionService.UpdateRfiLaborCategoryMatch
     */ updateRfiLaborCategoryMatch: {
            name: "UpdateRfiLaborCategoryMatch",
            I: UpdateRfiLaborCategoryMatchRequest,
            O: UpdateRfiLaborCategoryMatchResponse,
            kind: MethodKind.Unary
        },
        /**
     * Creates the capability-statement section and inserts its Heading 1 at the
     * start of the response document (update + writing_workspace_v1). Idempotent.
     *
     * @generated from rpc mono.projectdata.v1.RfiSectionService.EnsureRfiCapabilityStatement
     */ ensureRfiCapabilityStatement: {
            name: "EnsureRfiCapabilityStatement",
            I: EnsureRfiCapabilityStatementRequest,
            O: EnsureRfiCapabilityStatementResponse,
            kind: MethodKind.Unary
        }
    }
};
